import React from 'react';
import WebMasterPhoto from '../assets/WebMaster.jpg';

const Memorial: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-church-light to-white">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-church-dark mb-4">
              In Memoriam
            </h1>
            <div className="w-24 h-1 bg-church-gold mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 italic">
              "Blessed are the dead who die in the Lord from now on... that they may rest from their labors, for their deeds follow them!" - Revelation 14:13
            </p>
          </div>

          {/* Memorial Content */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="md:flex">
              {/* Photo Section */}
              <div className="md:w-1/3 p-8 bg-gray-50 flex flex-col items-center justify-center">
                <div className="w-48 h-48 rounded-full overflow-hidden shadow-lg mb-4">
                  <img 
                    src={WebMasterPhoto} 
                    alt="Tony Westbrook" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <h2 className="text-2xl font-bold text-church-dark mb-2">
                  Tony Westbrook
                </h2>
                <p className="text-church-gold font-semibold mb-2">
                  Website Administrator
                </p>
                <p className="text-gray-600 text-center">
                  Dedicated servant of our parish community
                </p>
              </div>

              {/* Content Section */}
              <div className="md:w-2/3 p-8">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6">
                    We remember with gratitude Tony Westbrook, who faithfully served our parish as website administrator. 
                    Tony was a quiet, dedicated man who used his skills to serve God and our community.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6">
                    Through his work maintaining our parish website, Tony helped keep our community connected. 
                    He ensured that parishioners could access Mass times, parish news, and stay informed about 
                    our community life. His service was given freely and with love.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6">
                    Tony was known for his gentle nature and willingness to help. He worked quietly behind 
                    the scenes, never seeking praise, but always ensuring our digital ministry served the 
                    needs of our parish family.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6">
                    We are grateful for Tony's years of faithful service and remember him with affection. 
                    His contribution to our parish community will not be forgotten.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Prayer Section */}
          <div className="mt-12 text-center">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold text-church-dark mb-6">
                Eternal Rest
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed italic">
                "Eternal rest grant unto Tony, O Lord, and let perpetual light shine upon him. 
                May his soul and the souls of all the faithful departed, through the mercy of God, rest in peace. Amen."
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Memorial;